import comp from "./PromptSuggestionModal";
export default comp;
